import React, { Component } from 'react';
import PropTypes from "prop-types";
import translate from '../../services/translation';

// labels outside this set have no headline/text (see getLabelHeadline/getLabelText below)
// and would render an empty favouriteItemLabelWrapper, e.g. stray/malformed Solr values
// Engage temporarily deactivated site-wide until an alternative exists (deadline 2026-09-27).
// Remove 'Engage', 'EngageInternal', 'EngageOfficial' from the exclusion list below to reinstate.
const DISABLED_LABELS = ['Engage', 'EngageInternal', 'EngageOfficial'];

const KNOWN_LABELS = [
    'Engage', 'EngageInternal', 'EngageOfficial', 'Exclusiv', 'Expert',
    'Family', 'New', 'Slow', 'Top', 'InstantBookable',
].filter((label) => !DISABLED_LABELS.includes(label));

export default class LabelPopup extends Component {
    static propTypes = {
        labels: PropTypes.array,
        labelPopupShow: PropTypes.object
    };

    state = {
        labelPopupShow: {},
    };

    handleMouseEnter = (label) => {
        this.setState((prevState) => ({
            labelPopupShow: {
                ...prevState.labelPopupShow,
                [label]: true,
            },
        }));
    };

    handleMouseLeave = (label) => {
        // Set the corresponding label's popup to false
        this.setState((prevState) => ({
            labelPopupShow: {
                ...prevState.labelPopupShow,
                [label]: false,
            },
        }));
    };

    render() {
        const { labels } = this.props;
        const { labelPopupShow } = this.state;

        const visibleLabels = labels.filter((label) => KNOWN_LABELS.includes(label));

        if (visibleLabels.length === 0) {
            return null;
        }

        return (
            <div className="favouriteItemLabelWrapper">
                {visibleLabels.map((label) => (
                    <div key={crypto.randomUUID()} className="favouriteItemLabels">
                        <div
                            className={'favouriteItemLabel ' + label}
                            onMouseEnter={() => this.handleMouseEnter(label)}
                            onMouseLeave={() => this.handleMouseLeave(label)}
                        >
                            <span className="favouriteItemLabelText hiddenText">
                                {translate('itinerary_item.label')}
                            </span>
                            <span className="favouriteItemLabelIcon" />
                        </div>

                        {labelPopupShow[label] && (
                            <div className={'addLabelPopup'}>
                                <div className={'addLabelPopup--text'}>
                                    <p className={'addLabelPopup--headline'}>{this.getLabelHeadline(label)}</p>
                                    <p>{this.getLabelText(label)}</p>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        );
    }

    getLabelHeadline = (label) => {
        switch (label) {
            case 'Engage':
                return translate('label_internal_headline');
            case 'EngageInternal':
                return translate('label_internal_headline');
            case 'EngageOfficial':
                return translate('label_official_headline');
            case 'Exclusiv':
                return translate('label_exclusiv_headline');
            case 'Expert':
                return translate('label_expert_headline');
            case 'Family':
                return translate('label_family_headline');
            case 'New':
                return translate('label_new_headline');
            case 'Slow':
                return translate('label_slow_headline');
            case 'Top':
                return translate('label_top_headline');
            case 'InstantBookable':
                return translate('label_instantbookable_headline');
            default:
                return '';
        }
    };

    getLabelText = (label) => {
        switch (label) {
            case 'Engage':
                return translate('label_internal_text');
            case 'EngageInternal':
                return translate('label_internal_text');
            case 'EngageOfficial':
                return translate('label_official_text');
            case 'Exclusiv':
                return translate('label_exclusiv_text');
            case 'Expert':
                return translate('label_expert_text');
            case 'Family':
                return translate('label_family_text');
            case 'New':
                return translate('label_new_text');
            case 'Slow':
                return translate('label_slow_text');
            case 'Top':
                return translate('label_top_text');
            case 'InstantBookable':
                return translate('label_instantbookable_text');
            default:
                return '';
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/Favourites/LabelPopup.js